import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { NetWorthTable } from './NetWorthTable/NetWorthTable';
import { NetWorthChart } from './NetWorthChart/NetWorthChart';
import { NetWorthContent } from './NetWorthStyles';
import { netWorthReducerPrefix } from '../MoneyGuideProConstants';
import { netWorthSelector } from '../MoneyGuidProSelectors';
import { TabProps } from '../MoneyGuideProTypes';
import { Tab } from '../Tab/Tab';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { NETWORTH_DESCRIPTION } from './NetWorth.meta';

export const NetWorth: React.FC<TabProps> = ({ id, clientId }) => {
  const data = useSelector(netWorthSelector);

  return (
    <Tab
      tabTitle="Net Worth Summary"
      mgpItemId={id}
      clientId={clientId}
      asOfDate={data ? data.asOfDate : null}
      reducerPrefix={netWorthReducerPrefix}
      isEmpty={data === null}
      isPristine={data === undefined}
    >
      {data ? (
        <>
          <Box mx="4">
            <Text as="p" fontSize="h6" mt="12">
              {NETWORTH_DESCRIPTION}
            </Text>
          </Box>
          <NetWorthContent>
            <NetWorthChart data={data.chartData} />
            <NetWorthTable data={data.tableData} />
          </NetWorthContent>
        </>
      ) : null}
    </Tab>
  );
};
